import BulkEditor from '@/src/components/BulkEditor/BulkEditor';
import { getSalesChannelTimezoneGmt } from '@/src/constrains/SalesChannelHOC/slice';
//import css from './table.module.less';
import StatusTag from '@/src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/StatusTag';
import { useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { modal } from '@/src/utils/Modal';
import arrayMove from 'array-move';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import EditDraggableTable from 'src/components/DroppableTable/EditDraggableTable';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import Action from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import {
  deletePromotionTags,
  getPromotionTags,
  postPromotionTagsSort,
} from 'src/request/salesChannel/promotionTag';
import { msg } from 'src/tools/message';
import { i18nGet, handleOnFormatCurrentSCTimeAndDate } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
const ActiveTable = (props) => {
  const timezoneGmt = useSelector(getSalesChannelTimezoneGmt());
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { setIndex, userPermissions } = props;
  const { uuid: salesChannelUuid }: any = useParams();
  const h = useHistory();
  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState(false);
  //const [total, setTotal] = React.useState(0);
  React.useEffect(() => {
    getPromotionTags(salesChannelUuid, 'Active').then((res: any) => {
      setData(res);
      setIndex(res.length);
    });
  }, []);

  const col = [
    {
      title: getI18n('salesChannelPromotionTag.index.tagTitle'),
      dataIndex: 'title',
      key: 'title',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { title } = record;
        return (
          <NoWrapContainer>
            <Tooltip title={title}>{title}</Tooltip>
          </NoWrapContainer>
        );
      },

      minWidth: 200,
    },
    {
      title: getI18n('salesChannelPromotionTag.index.numberofProducts'),
      // dataIndex: 'number',
      key: 'number',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { linkedProducts } = record;
        const len = (linkedProducts || []).length;
        return (
          <NoWrapContainer>
            <Tooltip title={len}>{len}</Tooltip>
          </NoWrapContainer>
        );
      },

      fixedWidth: 140,
    },
    {
      titleGenerate: () => getI18n('general.status'),
      position: EnumTablePosition.mid,
      key: 'status',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { status } = record;
        return <StatusTag status={status} />;
      },

      fixedWidth: 160,
    },
    {
      title: `${getI18n(
        'salesChannelPromotionTag.index.startTime',
      )} (UTC ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'createdTime',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { startTime } = record;
        const t = handleOnFormatCurrentSCTimeAndDate(startTime);
        return startTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },

      fixedWidth: 200,
    },
    {
      title: `${getI18n(
        'salesChannelPromotionTag.index.endTime',
      )} (UTC ${timezoneGmt})`,
      // dataIndex: 'number',
      key: 'finishTime',
      default: true,
      optional: false,
      childGenerate: (url, record) => {
        const { endTime } = record;
        const t = handleOnFormatCurrentSCTimeAndDate(endTime);
        return endTime ? (
          <NoWrapContainer>
            <Tooltip title={t}>{t}</Tooltip>
          </NoWrapContainer>
        ) : (
          '-'
        );
      },
      fixedWidth: 200,
    },
    (userPermissions.canDelete || userPermissions.canViewDetails) && {
      titleGenerate: () =>
        getI18n('general.advancedFilters.commonStoreProductsWithTable.actions'),
      position: EnumTablePosition.mid,
      dataIndex: 'action',
      default: true,
      optional: true,
      key: 'action',
      //className: css.columnClass,
      fixedWidth: 128,
      childGenerate: (text, record, index) => {
        const { uuid } = record;
        return (
          <Action
            onEdit={
              userPermissions.canViewDetails &&
              (() => {
                h.push(
                  `/salesChannel/promotionTag/editor/${salesChannelUuid}/${uuid}`,
                );
              })
            }
            onDelete={
              userPermissions.canDelete &&
              (() => {
                modal.error({
                  title: getI18n(
                    'salesChannelPromotionTag.index.deletePromotionTag',
                  ),
                  content: getI18n(
                    'salesChannelPromotionTag.index.deletePromotionTagErrtitle',
                  ),
                  onOkText: getI18n('general.delete'),
                  onCancel: () => {
                    return;
                  },
                  onOk: () => {
                    setLoading(true);
                    deletePromotionTags({
                      salesChannelUuid,
                      uuids: [uuid],
                    }).then((res) => {
                      const _d = data.filter((i) => uuid !== i.uuid);
                      setData(_d);
                      msg.success(
                        getI18n(
                          'salesChannelPromotionTag.index.tagshavebeendeleted',
                        ),
                      );
                      setLoading(false);
                    });
                  },
                });
              })
            }
          />
        );
      },
    },
  ];

  const buttonMenu = [
    //Bulk Edit
    {
      key: '1',
      value: getI18n('salesChannelPromotionTag.index.deleteTags'),
      function: () => {
        //console.log('selectedRowKeys', selectedRowKeys);

        modal.error({
          title: getI18n('salesChannelPromotionTag.index.deletePromotionTag'),
          content: getI18n(
            'salesChannelPromotionTag.index.deletePromotionTagErrtitle',
          ),
          onOkText: getI18n('general.delete'),
          onCancel: () => {
            return;
          },
          onOk: () => {
            setLoading(true);
            deletePromotionTags({
              salesChannelUuid,
              uuids: selectedRowKeys,
            }).then((res) => {
              const _d = data.filter((i) => !selectedRowKeys.includes(i.uuid));
              setData(_d);
              msg.success(
                getI18n('salesChannelPromotionTag.index.tagshavebeendeleted'),
              );
              setLoading(false);
            });
          },
        });
      },
      disabled: !userPermissions.canDelete,
    },
  ];

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // //mappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(data);
  const selectAll = () => {
    //TODO:选择全部待确认，是否需要从后端拿到全部的uuid
    const allSelect = data.map((item) => {
      return item.uuid;
    });
    if (setSelectedAll) setSelectedAll(true);
    rowSelection.onChange(allSelect);
  };

  const onChange = (e, value) => {
    //console.log(value);
    const { from, to } = value;
    if (from === to) {
    } else {
      const _d: any = arrayMove(data, from, to);
      setData(_d);
      setLoading(true);
      postPromotionTagsSort({
        salesChannelUuid,
        uuids: _d.map((i) => i.uuid),
      }).then((res) => {
        setLoading(false);
      });
    }

    // move(from, to);
  };

  return (
    <React.Fragment>
      <BulkEditor
        selectAll={selectAll}
        selectedAll={selectedAll}
        buttonMenu={buttonMenu}
        total={(data || []).length}
        dataSource={data}
        selectedRowKeys={selectedRowKeys} //mappedSelectedKeys}
        //allSelected={mappedSelectedKeys}
      />
      <EditDraggableTable
        id='salesChannelPromotionTagList'
        dataSource={data}
        loading={loading}
        columns={col}
        rowSelection={rowSelection}
        rowKey='uuid'
        pagination={false}
        hideAllDragHandlers={!userPermissions.canCreate}
        onTableChange={(e, value) => {
          if (onChange) onChange(e, value);
        }}
      />
    </React.Fragment>
  );
};

export default ModalHoc(ActiveTable);
